// The heavy half of startup, split out of main.jsx so the entry chunk stays
// tiny. main.jsx dynamic-imports this AFTER the browser has painted the static
// hero, so evaluating the React graph (react-dom + framer-motion + the App
// tree) no longer blocks the first paint / LCP.
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(<App />)
